<template>
  <Modal
    v-model="isOpen"
    closeCross
    class="ActionErrorModal"
    :title="t('ui.subscription.cancelPlan.fail.title')"
    :titleIcon="{
      icon: 'alert',
      color: 'warning'
    }"
  >
    <div class="ActionErrorModal-content">
      <p class="u-textSecondary u-text-md">
        {{ t('ui.subscription.cancelPlan.fail.description') }}
        <br>
        <br>
        {{ t('ui.subscription.cancelPlan.fail.contact') }}
      </p>
    </div>

    <template #actionPrimary>
      <ActionButton
        variant="primary"
        :size
        @click="handleRetry"
      >
        {{ t('ui.subscription.cancelPlan.fail.action') }}
      </ActionButton>
    </template>
  </Modal>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  retry: [];
}>();
const isOpen = defineModel<boolean>({ default: false });

const { t } = useI18n();
const { isMobile } = useResponsive();
const size = computed(() => (isMobile.value ? 'sm' : 'md'));

function handleRetry() {
  emit('retry');
};
</script>

<style lang="scss">
@use 'assets/scss/theme' as vars;

@layer cvo-base {
  .ActionErrorModal {
    max-width: 480px;

    &-content {
      display: flex;
      flex-direction: column;
      gap: vars.$dimensions-d-8;
      align-items: center;
      margin-top: vars.$dimensions-d-6;
    }
  }
}
</style>
